/** @module csi/widget/_svg/AddPageDropDownMenuItemType */
define([
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"dijit/_TemplatedMixin",
	"csi/html",
	"dojo/text!./resources/AddPageDropDownMenuItemType.html"
], function(declare,_WidgetBase,_TemplatedMixin,html,template){
	return declare([_WidgetBase, _TemplatedMixin], {
		templateString: template,

		// label for each menu item type
		label: "",
	});
});
